import React from 'react';
import {
  ComponentVerticalSpacing,
  ComponentWrapper,
  Avatar
} from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

import Svg from './Svg';

const Way = props => {
  const { data } = props;
  return (
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="d8-c-tsw-why d8-u-contrast-low-bg padding-md d8-u-relative">
          <Svg className="yellow-triangles" name="yellow-triangles" />
          <Svg className="green-triangles" name="green-triangles" />
          <div className="zigzag-wrap">
            <Svg name="zigzag" />
            <Svg name="zigzag" />
            <Svg name="zigzag" />
          </div>
          <div className="max-width-md margin-auto">
            <div className="grid grid-gap-sm component">
              <div className="col-12">
                <h2 className="text-center margin-y-lg">{data.title}</h2>
              </div>
              {data.items.map((item, i) => (
                <div key={i} className="col-4@sm">
                  <div className="text-component margin-bottom-xl">
                    <Avatar
                      initials={i + 1}
                      avatar-Size="avatar-xs"
                    />
                    <h4 className="d8-u-font-size-base d8-u-ls-sm">{item.title}</h4>
                    <p>
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  );
};


Way.propTypes = {
  data: PropTypes.object
};

export default Way;
